module.exports = {
  'app-primary-color': process.env.VUE_APP_THEME_PRIMARY_COLOR,
  'app-primary-accent-color': process.env.VUE_APP_THEME_ACCENT_COLOR,
  'app-danger-color': process.env.VUE_APP_THEME_DANGER_COLOR,
  'app-block-color': process.env.VUE_APP_THEME_BLOCK_BG_COLOR,
  'app-text-color': process.env.VUE_APP_THEME_TEXT_COLOR,
  'app-box-shadow-color': process.env.VUE_APP_THEME_BOX_SHADOW_COLOR,
  'app-input-bg-color': process.env.VUE_APP_THEME_INPUT_BG_COLOR,
  'app-input-title-color': process.env.VUE_APP_THEME_INPUT_TITLE_COLOR,
  'app-input-placeholder-color': process.env.VUE_APP_THEME_INPUT_DISABLED_COLOR,
  'app-primary-gradient-color-from': process.env.VUE_APP_THEME_PRIMARY_GRADIENT_COLOR_FROM,
  'app-primary-gradient-color-to': process.env.VUE_APP_THEME_PRIMARY_GRADIENT_COLOR_TO
}